import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, User, Settings } from 'lucide-react';
import { ROUTES } from '../routes';

export const MobileNavigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path: string) => {
    if (path === ROUTES.HOME) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-kind-graphite border-t border-gray-300 dark:border-white/10"
      style={{
        position: 'fixed',
        bottom: '0px',
        left: '0px',
        right: '0px',
        top: 'auto',
        zIndex: 99999,
        height: '80px',
        display: 'block',
        transform: 'none',
        width: '100vw',
        maxWidth: '100vw',
        overflow: 'visible',
      }}
    >
      <div className="flex items-center justify-around px-2 py-2 h-full">
        <button
          onClick={() => navigate(ROUTES.HOME)}
          className={`flex flex-col items-center space-y-1 p-3 rounded-xl transition-all duration-200 ${
            isActive(ROUTES.HOME)
              ? 'bg-kind-purple text-white'
              : 'text-kind-text-secondary hover:text-kind-text-primary'
          }`}
        >
          <Home className="w-5 h-5" />
          <span className="text-xs font-medium">Home</span>
        </button>

        <button
          onClick={() => navigate(ROUTES.PROFILE)}
          className={`flex flex-col items-center space-y-1 p-3 rounded-xl transition-all duration-200 ${
            isActive(ROUTES.PROFILE)
              ? 'bg-kind-purple text-white'
              : 'text-kind-text-secondary hover:text-kind-text-primary'
          }`}
        >
          <User className="w-5 h-5" />
          <span className="text-xs font-medium">Profile</span>
        </button>

        <button
          onClick={() => navigate(ROUTES.SETTINGS)}
          className={`flex flex-col items-center space-y-1 p-3 rounded-xl transition-all duration-200 ${
            isActive(ROUTES.SETTINGS)
              ? 'bg-kind-purple text-white'
              : 'text-kind-text-secondary hover:text-kind-text-primary'
          }`}
        >
          <Settings className="w-5 h-5" />
          <span className="text-xs font-medium">Settings</span>
        </button>
      </div>
    </div>
  );
};
